'use es6';

/* global hubspot */
import Interframe from 'interframe';
import Backbone from 'Backbone';
import apiClient from 'hub-http/clients/apiClient';
import { apiResponderMiddleware } from 'interframe/proxy/api-responder';
import apiProxyMiddlewareAllowlist from 'ContentEditorUI/constants/ApiProxyMiddlewareAllowlist';
import { uploadFile } from 'tinymce-data/api/FileManager';
import { uploadFileV3 } from 'FileManagerCore/api/Files';
import { DropZoneWithBrowseFileAccess } from 'FileManagerLib/enums/FileAccess';
import { LocalStoreHandlers } from 'rich-text-lib/utils/localStore';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const http = apiClient.default != null ? apiClient.default : apiClient;
class EventBusEmailDnd {
  constructor() {
    this.ready = false;
    this.iframeInitializing = false;
    this.onPostMessage = this.onPostMessage.bind(this);
    Object.assign(this, Backbone.Events);

    // Stores messages that we attempt to send before the connection is established
    this.pendingMessages = [];

    // actions that need the iframe store to be inited before being sent
    this.pendingReduxActions = [];
    this.bindInitializationEvents();
  }
  bindInitializationEvents() {
    this.on('post:uploadFileEmailDnd', message => {
      const file = new File([message.fileAsBlob], message.fileMeta.name, message.fileMeta);
      const handleProgress = event => {
        return this.messenger.postMessage({
          action: 'uploadFileEmailDndProgress',
          requestId: message.requestId,
          loaded: event.loaded,
          total: event.total,
          moduleId: message.moduleId
        });
      };
      return uploadFileV3(file, DropZoneWithBrowseFileAccess.VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE, {}, {
        updateProgress: handleProgress,
        httpClient: http
      }).then(response => {
        return this.messenger.postResponse(message, response.toJS());
      }).catch(error => {
        FloatingAlertStore.addAlert({
          type: 'danger',
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "fileUpload.error.title"
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "fileUpload.error.message",
            options: {
              filename: file.name
            }
          })
        });
        console.error(error);
        this.messenger.postResponse(message, {
          error: true
        });
      });
    });
    this.on('post:uploadFile', message => {
      const {
        file
      } = message;
      const handleProgress = event => {
        return this.messenger.postMessage({
          action: 'uploadFileProgress',
          requestId: message.requestId,
          loaded: event.loaded,
          total: event.total,
          moduleId: message.moduleId
        });
      };
      return uploadFile(file, handleProgress, http, DropZoneWithBrowseFileAccess.VISIBLE_IN_APP_PUBLIC_TO_ALL_NOT_INDEXABLE).then(response => {
        return this.messenger.postResponse(message, response);
      }).catch(error => {
        FloatingAlertStore.addAlert({
          type: 'danger',
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "fileUpload.error.title"
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "fileUpload.error.message",
            options: {
              filename: file.name
            }
          })
        });
        console.error(error);
        return this.messenger.postResponse(message, {
          error: true
        });
      });
    });
    this.on('post:getStoreValues', message => {
      const {
        storeKeys,
        storeNamespace
      } = message.payload;
      const store = LocalStoreHandlers.getStore(window, storeKeys, storeNamespace);
      return this.messenger.postResponse(message, store);
    });
    this.on('post:setStoreValue', message => {
      const {
        key,
        value,
        storeKeys,
        storeNamespace
      } = message.payload;
      return LocalStoreHandlers.setValue(window, storeKeys, storeNamespace, {
        key,
        value
      });
    });
  }
  removeBoundInitializationEvents() {
    this.off('post:getStoreValues');
    this.off('post:setStoreValue');
    this.off('post:uploadFile');
    this.off('post:uploadFileEmailDnd');
  }
  getStore() {
    return hubspot.ContentEditorUI.store;
  }
  setupMessagingToFrame(otherWindow, previewDomain = window.hsPreviewDomain) {
    this.messenger = new Interframe(`${document.location.protocol}//${previewDomain}`, otherWindow, {
      middleware: apiResponderMiddleware(http, apiProxyMiddlewareAllowlist)
    });
    this.messenger.subscribe(this.onPostMessage);
    // Send all messages that we attempted to send before the connection was set up
    for (const msg of Array.from(this.pendingMessages)) {
      this.postMessage(msg.message, msg.type, msg.callback);
    }
    return this.pendingMessages = [];
  }
  postMessage(message, type, callback) {
    if (this.messenger) {
      if (message && message.action === 'reduxAction' && this.iframeInitializing) {
        return this.addPendingReduxAction(message, type);
      } else if (callback) {
        return this.messenger.postMessage(message, type).then(callback);
      } else {
        return this.messenger.postMessage(message, type);
      }
    } else {
      return this.pendingMessages.push({
        message,
        type
      });
    }
  }
  addPendingReduxAction(message, type) {
    return this.pendingReduxActions.push({
      message,
      type
    });
  }
  messagePendingReduxActions() {
    if (this.iframeInitializing) {
      this.iframeInitializing = false;
      for (const msg of Array.from(this.pendingReduxActions)) {
        this.postMessage(msg.message, msg.type, msg.callback);
      }
      this.pendingReduxActions = [];
    }
  }
  setIframeStoreInitializing() {
    this.ready = true;
    this.iframeInitializing = true;
  }
  onPostMessage(message) {
    return this.trigger(`post:${message.action}`, message);
  }
  getComputedStyle(eventData, callback) {
    return this.postMessage(Object.assign({}, eventData, {
      action: 'getComputedStyle'
    }), null, callback);
  }
  getComputedStylesForSelectors(eventData, callback) {
    return this.postMessage(Object.assign({}, eventData, {
      action: 'getComputedStylesForSelectors'
    }), null, callback);
  }
}
export default new EventBusEmailDnd();